import React from 'react';
import styles from './Header.module.sass';
import cn from 'classnames';

export interface HeaderProps {
  onOpen?: () => void;
  title?: React.ReactNode;
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ onOpen, title, className }) => {
  return (
    <header className={cn(styles.header, className)}>
      <div className={styles.titleContainer}>
        {title && (
          <h1 className={styles.title} id="page-title">
            {title}
          </h1>
        )}
        <button className={styles.burger} onClick={onOpen}></button>
      </div>

      <div className={styles.control}>
        <a
          className={styles.logo}
          href="https://www.trend.io/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            height={48}
            src="/images/trend-logo-black.svg"
            alt="trend-logo"
          />
        </a>
      </div>
    </header>
  );
};

export default Header;
